import { env } from 'app/Env/env';

export const getUrlParams = () => {
	const queryString = window.location.search;
	return new URLSearchParams(queryString);
};

export const getUrlParam = (name: string) => {
	const params = getUrlParams();
	/* istanbul ignore if: no need to test this */
	if (params.has(name)) {
		return params.get(name);
	}
	return null;
};

// the Descope auth API shares its origin with the sso-app API, which is
// env.baseUrl (ending in /sso-app) or, when that is missing or relative, the page itself
export const descopeApiOrigin = () =>
	new URL(env.baseUrl || '/', window.location.href).origin;
